import { prefersReducedMotion } from '@theme/utilities';

const SELECTOR = '.text-block, .product-card, .card';
const STAGGER_STEP_MS = 100;
const STAGGER_MAX_STEPS = 6;

function init() {
  const main = document.getElementById('MainContent');
  if (!main || prefersReducedMotion()) return;

  const targets = Array.from(main.querySelectorAll(SELECTOR));
  if (targets.length === 0) return;

  main.setAttribute('data-scroll-reveal-ready', '');

  const staggerIndex = new Map();

  targets.forEach((el) => {
    el.setAttribute('data-scroll-reveal', '');

    const parent = el.parentElement;
    const index = staggerIndex.get(parent) || 0;
    staggerIndex.set(parent, index + 1);

    const step = Math.min(index, STAGGER_MAX_STEPS);
    el.style.setProperty('--scroll-reveal-delay', `${step * STAGGER_STEP_MS}ms`);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal--visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  targets.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
